import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ProductShotBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";

export const meta: ComponentMeta = {
  name: "Product Card",
  version: 1,
  isHidden: true,
  nameI18n:
    "settings.emails.visual_builder.block_type.product_shot.product_card",
  category: [ProductShotBlock],
  props: {},
};
